import React, { useContext, useEffect, useMemo } from "react";

import { ColumnProps, FormContext, FormInput, FormNumber, FormSelect, Table } from '@digital/ui';
import { getCkRhComentario, postCkRhComentario } from "@app/api/sas/relatorioHomologacao";
import { isObjEmpty } from "@app/helpers/objHelper";
import { isValidGuid } from "@app/helpers/geradorGuid";
import ModalComentarioButton from "@app/components/ModalComentarios";
import { EGuidPerfilAcesso } from "@app/enums/EGuidPerfilAcesso";
import { hasPermissionPerfil } from "@app/helpers/permissions";

interface FormTableAbaChecklistReajusteProps {
    dataSource: any[];
    ehComprador?: boolean;
}

const FormTableAbaChecklistReajuste = ({ dataSource, ehComprador }: FormTableAbaChecklistReajusteProps) => {
    const { formProps } = useContext(FormContext);

    useEffect(() => {
        if (formProps) {
            formProps!.resetForm();
            dataSource.map(m => {
                if (m.resposta) {
                    formProps!.setFieldValue(`resposta|${m.passo}`, m.resposta);
                }

                if (m.respostas && isValidGuid(m.respostaId)) {
                    formProps!.setFieldValue(`respostas|${m.passo}`, m.respostaId);
                }

                if (m.observacoes) {
                    formProps!.setFieldValue(`observacoes|${m.passo}`, m.observacoes);
                }
            });
        }
    }, [dataSource]);

    const columnsContratoServicos = useMemo(() => {
        const columns: ColumnProps<any>[] = ([] = new Array());

        columns.push({
            title: 'Passo',
            dataIndex: 'passo',
            width: '1%',
            align: 'center'
        });

        columns.push({
            title: 'Descrição',
            dataIndex: 'descricao',
            width: '40%',
        });

        columns.push({
            title: 'Resposta',
            dataIndex: 'resposta',
            width: '10%',
            render: (_text, record) => {
                if (!record.respostas || isObjEmpty(record.respostas)) {
                    return (
                        <FormNumber
                            name={`resposta|${record.passo}`}
                            min={0}
                            max={100}
                            maxLength={5}
                            step={0.01}
                            disabled={!ehComprador}
                        />
                    );
                } else {
                    return (
                        <FormSelect
                            name={`respostas|${record.passo}`}
                            options={record.respostas}
                            onChange={e => {
                                return formProps!.setFieldValue(`respostas|${record.passo}`, e);
                            }}
                            disabled={!ehComprador}
                        />
                    );
                }
            }
        });

        columns.push({
            title: 'Ação',
            width: '29%',
            render: (_text, record) => {

                if (!record.respostas || isObjEmpty(record.respostas)) {
                    return "N/A";
                } else {
                    const respostaIdPasso = formProps!.values[`respostas|${record.passo}`];
                    const acao = record.acoesRespostas.find(f => f.value == respostaIdPasso);
                    if (acao) {
                        return <span>{acao.text}</span>;
                    }
                    return "";
                }
            }
        });

        columns.push({
            title: 'Observações do Comprador',
            dataIndex: 'observacoes',
            width: '20%',
            render: (_text, record) => {
                return (
                    <FormInput
                        name={`observacoes|${record.passo}`}
                        disabled={!ehComprador}
                    />
                );
            }
        });

        if (hasPermissionPerfil([EGuidPerfilAcesso.GerenteDepartamentoSas, EGuidPerfilAcesso.GerenteGeralSas])) {
            columns.push({
                title: 'Comentários',
                width: '10%',
                render: (_text, record) => {
                    return (
                        <ModalComentarioButton
                            readonly={false}
                            loadAllComentarios={() => {
                                return getCkRhComentario(record.id)
                                    .then((data: any) => {
                                        if (data) {
                                            return data.comentarios;
                                        }
                                        return [];
                                    })
                                    .catch(() => {
                                        return [];
                                    });
                            }}
                            handleEnviarComentario={(msg) => postCkRhComentario(record.id, msg)}
                            showBadgeComments={true}
                        />
                    );
                }
            });
        }


        return columns;
    }, [dataSource, formProps]);

    return (
        <Table
            columns={columnsContratoServicos}
            dataSource={dataSource}
            pagination={false}
        />
    );
};

export default FormTableAbaChecklistReajuste;